import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import PropTypes from "prop-types";
import {
  Autocomplete,
  FormControl,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { formFieldError } from "../../../modules/hcmd/components/formUtils";
import {
  getCounties,
  getCountriesAutocomplete,
} from "../../../services/dictionary";
import Grid from "@mui/material/Unstable_Grid2";

const FilterPreferencesForwardRef = (props, ref) => {
  const { params, site } = props;

  const counties = params.counties ?? [];
  const fieldsOfWorkCategories = params.fieldsOfWorkCategories ?? [];
  const initial = params.initialValue || {};
  const initialCountyObjects = (initial.countyValues ?? []).map((id) => {
    const opt = counties.find((c) => c.id === id);
    return opt ?? { id, name: `#${id}` };
  });
  const initialFowObjects = (initial.fowValues ?? []).map((id) => {
    const opt = fieldsOfWorkCategories.find((c) => c.id === id);
    return opt ?? { id, name: `#${id}` };
  });
  const [countyValues, setCountyValues] = useState(initialCountyObjects);
  const [fowValues, setFowValues] = useState(initialFowObjects);

  useImperativeHandle(ref, () => ({
    getFilter() {
      const filter = {};
      if (countyValues) {
        filter.userCountyPreferences = { countyId: { inq: countyValues } };
      }
      if (fowValues) {
        filter.userFieldsOfWorkCategoryPreferences = {
          fieldsOfWorkCategoryId: { inq: fowValues },
        };
      }
      return filter;
    },
    getValue() {
      if (!countyValues.length && !fowValues.length) return null;
      return {
        countyValues: countyValues.map((c) =>
          typeof c === "object" ? c.id : c
        ),
        fowValues: fowValues.map((c) => (typeof c === "object" ? c.id : c)),
      };
    },
    getDisplayValue() {
      if (!countyValues.length && !fowValues.length) return null;
      return `${params.name}: ${countyValues.length} megye / ${fowValues.length} terület`;
    },
  }));

  return (
    <Grid container spacing={2}>
      <Grid>
        <label className={` col-form-label fw-bold fs-6`}>{params.name}</label>
      </Grid>
      <Grid className={`fv-row`}>
        <Grid container direction={"column"}>
          <Grid>
            <FormControl sx={{ width: "100%" }}>
              <Autocomplete
                name={`${params.field}-counties`}
                multiple={true}
                options={counties}
                isOptionEqualToValue={(option, value) => {
                  return option.id === value;
                }}
                getOptionLabel={(option) => option.name ?? ""}
                onChange={(event, value) => {
                  setCountyValues(value ?? []);
                }}
                value={countyValues}
                renderInput={(params) => (
                  <TextField {...params} placeholder={"Több is választható"} />
                )}
              ></Autocomplete>
            </FormControl>
          </Grid>
          <Grid>
            <FormControl sx={{ width: "100%" }}>
              <Autocomplete
                name={`${params.field}-fields-of-work-categories`}
                multiple={true}
                options={fieldsOfWorkCategories}
                isOptionEqualToValue={(option, value) => {
                  return option.id === value;
                }}
                getOptionLabel={(option) => option.name ?? ""}
                onChange={(event, value) => {
                  setFowValues(value ?? []);
                }}
                value={fowValues}
                renderInput={(params) => (
                  <TextField {...params} placeholder={"Több is választható"} />
                )}
              ></Autocomplete>
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
const FilterPreferences = forwardRef(FilterPreferencesForwardRef);

FilterPreferences.propTypes = {
  params: PropTypes.object,
};

export default FilterPreferences;
